import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const PlateDesignTemplateRoutes: RouteBundle = {
  domain: 'plates',
  routes: [
    {
      urlPattern: ':currentUserUrl/plate-design-templates/:plateDesignTemplateId',
      handler: EditorRoutes.plateDesignTemplateEditor.bind(EditorRoutes),
    },
  ],
};
